import { Component, Input } from '@angular/core';

@Component({
    selector: 'data-list-image-cell',
    templateUrl: 'data-list-image-cell.html',
    styleUrls: ['data-list-image-cell.scss'],
    standalone: false
})
export class DataListImageCellComponent {
  @Input() fileId: string;
  @Input() placeholder: string;
}
